export { isHotkeyPressed, useHotkeys } from 'react-hotkeys-hook';

export type { Options as UseHotkeysOptions } from 'react-hotkeys-hook';
